import React, {useEffect, useState} from 'react';
import {DatePicker, Select} from 'antd';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";
import {PieChart} from "@mui/x-charts/PieChart";
import {styled} from "@mui/material/styles";
import {useDrawingArea} from "@mui/x-charts/hooks";
import dayjs from "dayjs";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import moment from "moment/moment";
import {Radar} from "@ant-design/plots";

const {RangePicker} = DatePicker;


const size = {
    width: 400,
    height: 200,
};

const StyledText = styled('text')(({theme}) => ({
    fill: theme.palette.text.primary,
    textAnchor: 'middle',
    dominantBaseline: 'central',
    fontSize: 20,
}));

function PieCenterLabel({children}) {
    const {width, height, left, top} = useDrawingArea();
    return (
        <StyledText x={left + width / 2} y={top + height / 2}>
            {children}
        </StyledText>
    );
}

const Home = () => {
    const [company, setCompany] = useState({})
    const [time, setTime] = useState(new Date());
    const [timeNow, setTimeNow] = useState(time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + Number(time?.getDate()));
    const [timeNowForChart, setTimeNowForChart] = useState("");
    const [tabs, setTabs] = useState(1)
    const [tabsTitle, setTabsTitle] = useState("absent")
    const [data2, setData2] = useState([])
    const [yesterday, setYesterday] = useState(getPreviousDay())
    const [absent_attendances_count, setabsent_attendances_count] = useState(0)
    const [late_attendances_count, setlate_attendances_count] = useState(0)
    const [on_time_attendances_count, seton_time_attendances_count] = useState(0)
    const [absent_attendances_count2, setabsent_attendances_count2] = useState(0)
    const [late_attendances_count2, setlate_attendances_count2] = useState(0)
    const [on_time_attendances_count2, seton_time_attendances_count2] = useState(0)
    const [topType, settopType] = useState(1)
    const dateFormat = 'YYYY-MM-DD';
    const [offices, setOffices] = useState([])
    const [building_id, setbuilding_id] = useState("")
    const [departments, setDepartments] = useState([])
    const [department_id, setdepartment_id] = useState("")
    const [dateFilter, setDateFilter] = useState(Number(time.getFullYear()) + "-" + Number(time.getMonth() + 1) + "-" + Number(time.getDate()))
    const [dateBuFilter, setDateBuFilter] = useState(null)
    const [usersObj, setUsersObj] = useState({})
    const [current, setCurrent] = useState(1);
    const [dateDeFilter, setDateDeFilter] = useState(null)
    let last_date = new Date(time.getFullYear(), time.getMonth() + 1, 0);
    const [data, setData] = useState([]);
    const [empData, setEmpData] = useState({});
    const [radarData, setRadarData] = useState([]);
    const [parents, setParents] = useState([])


    const getCompany = () => {
        if (localStorage.getItem("for_com")) {
            axios.get(API_PATH + "company/" + localStorage.getItem("for_com"), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setCompany(res.data)
                })
        }
    }

    function getPreviousDay(date = new Date()) {
        const previous = new Date(date.getTime());
        previous.getDay(date.getDay() - 1);

        return previous;
    }

    const getParentBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/sections/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": 			"Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setParents(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }

    const getBuilding = (val) => {

        axios.get(API_PATH + "company/" + localStorage.getItem('id') +"/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res.data)
                setDateBuFilter(res?.data[0]?.id)
                if (res?.data[0]?.id){
                    getDepsIntro(res?.data[0]?.id)
                }
            })
            .catch(err => {
                // toast.error("Ошибка")
            })

    }
    const today = new Date() // get today's date
    const tomorrow = new Date(today)
    tomorrow.setDate(today.getDate() + 1) // Add 1 to today's date and set it to tomorrow

    const getStatistik1 = (from_date, to_date) => {
        // axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/hr/attendance/statistics?from_date=" + from_date + "&to_date=" + to_date + "&building_id=" + building_id + "&department_id=" + department_id + Number(time?.getDate()), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
        axios.get(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/employee/working-analytics/graph?start_date_str=" + from_date + "&end_date_str=" + to_date, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                // setData(res?.data)
                setabsent_attendances_count(res?.data?.absent_attendances_count)
                seton_time_attendances_count(res?.data?.on_time_attendances_count)
                setlate_attendances_count(res?.data?.late_attendances_count)
                setData([{
                    value: res?.data?.absent_attendances_count,
                    label: 'Отсутствие'
                },
                    {
                    value: res?.data?.on_time_attendances_count,
                    label: 'Вовремя'
                },
                    {
                    value: res?.data?.late_attendances_count,
                    label: 'Опоздание'
                    }])

            })
            .catch(err => {
                toast.error("No data")
            })
    }
    const getStatistik2 = (from_date, to_date) => {
        // axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/hr/attendance/statistics?from_date=" + from_date + "&to_date=" + to_date + "&building_id=" + building_id + "&department_id=" + department_id + Number(time?.getDate()), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/hr/attendance/statistics?from_date=" + from_date + "&to_date=" + to_date, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                // setData(res?.data)
                setabsent_attendances_count2(res?.data?.absent_attendances_count)
                seton_time_attendances_count2(res?.data?.on_time_attendances_count)
                setlate_attendances_count2(res?.data?.late_attendances_count)
            })
            .catch(err => {
                toast.error("No data")
            })
    }

    function onChangeBuDate(building_e) {
        // console.log(dateDeFilter)
        setDateBuFilter(building_e)
        axios.get(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/employee/working-hours?date_str=" + dateFilter  + "&late_comers=" + ( tabsTitle === "late" ? "true" : "false") + "&on_time_employees=" + (tabsTitle === "on_time"  ? "true" : "false" )+ "&absentees=" + ( tabsTitle === "absent" ? "true" : "false" ) +  "&branch_id=" + building_e + (dateDeFilter > 0 ? "&department_id=" + dateDeFilter : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setData2(res.data.items)
            })
    }

    function onChangeDeDate(department_e, branch_e) {
        setDateDeFilter(department_e)
        setDateBuFilter(branch_e)
        axios.get(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/employee/working-hours?date_str=" +    dateFilter + "&late_comers=" + ( tabsTitle === "late" ? "true" : "false") + "&on_time_employees=" + (tabsTitle === "on_time"  ? "true" : "false" )+ "&absentees=" + ( tabsTitle === "absent" ? "true" : "false" ) +  "&branch_id=" + branch_e + "&department_id=" + department_e, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setData2(res.data.items)

            })
    }

    function onChange(date, dateString) {
        // console.log(dateString[0])
        // console.log(dateString[1])
        if (dateString[0] !== "" && dateString[1] !== ""){
            axios.get(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/employee/working-analytics/graph?start_date_str=" + dateString[0] + "&end_date_str=" + dateString[1], {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    // setData(res?.data)
                    setabsent_attendances_count(res?.data?.absent_attendances_count)
                    seton_time_attendances_count(res?.data?.on_time_attendances_count)
                    setlate_attendances_count(res?.data?.late_attendances_count)
                    setData([{
                        value: res?.data?.absent_attendances_count,
                        label: 'Отсутствие'
                    }, {
                        value: res?.data?.on_time_attendances_count,
                        label: 'Вовремя'
                    }, {value: res?.data?.late_attendances_count, label: 'Опоздание'}])

                })
                .catch(err => {
                    toast.error("No data")
                })
        } else {
            getStatistik1(Number(time?.getFullYear()) + "-" + Number(time?.getMonth() + 1) + "-" + Number(time?.getDate()), Number(time?.getFullYear()) + "-" + Number(time?.getMonth() + 1) + "-" + Number(time?.getDate()))

        }
    }

    function onChangeDate(date, dateString) {
        if (date !== null) {
            setDateFilter(dateString)
            setTimeNow(dateString)
            // console.log("nul emas")
            axios.get(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/employee/working-hours?date_str=" + dateString + "&late_comers=" + ( tabsTitle === "late" ? "true" : "false") + "&on_time_employees=" + (tabsTitle === "on_time"  ? "true" : "false" )+ "&absentees=" + ( tabsTitle === "absent" ? "true" : "false" ) + (dateBuFilter > 0 ? "&branch_id=" + dateBuFilter : "") + "" + (dateDeFilter > 0 ? "&department_id=" + dateDeFilter : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setData2(res.data.items)
                })
        } else {
            setDateFilter(Number(time.getFullYear()) + "-" + Number(time.getMonth()) + "-" + Number(time.getDate()))
            axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/hr/attendance/all?status=" + tabsTitle + "&for_date=" + Number(time.getFullYear()) + "-" + Number(time.getMonth() + 1) + "-" + Number(time.getDate()) + (dateBuFilter ? "&building_id=" + dateBuFilter : "") + (dateDeFilter ? "&department_id=" + dateDeFilter : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setData2(res.data.items)
                })
        }

        // console.log(date)
    }


    const getDeps = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/hr/department/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setDepartments(res.data?.items)
                // onChangeDeDate(res.data?.items[0]?.id, val)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getDepsIntro = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/hr/department/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setDepartments(res.data?.items)
                onChangeDeDate(res.data?.items[0]?.id, val)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }

    const changePagination = (current, size) => {

        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/hr/attendance/all?status=" + tabsTitle + "&for_date=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + Number(time?.getDate()) + "&page=" + size, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            // axios.get(API_PATH + "user/company/" + localStorage.getItem('id') + "/user/all?page=" + size, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setData2(res.data.items)
                setUsersObj(res.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }

    const getAll = (e) => {
        axios.get(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/employee/working-hours?date_str=" + timeNow + "&branch_id="+ dateBuFilter + "&late_comers=" + ( e === "late" ? "true" : "false") + "&on_time_employees=" + (e === "on_time"  ? "true" : "false" )+ "&absentees=" + ( e === "absent" ? "true" : "false" ) + "&department_id=" + dateDeFilter, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setData2(res.data.items)
                setUsersObj(res?.data)
            })
    }
    const getAllDeps = (e) => {
        setDateDeFilter(e)
        axios.get(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/employee/working-hours?date_str=" + timeNow + "&branch_id="+ dateBuFilter + "&late_comers=" + ( tabsTitle === "late" ? "true" : "false") + "&on_time_employees=" + (tabsTitle === "on_time"  ? "true" : "false" )+ "&absentees=" + ( tabsTitle === "absent" ? "true" : "false" ) + "&department_id=" + e, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setData2(res.data.items)
                setUsersObj(res?.data)
            })
    }
    const forChart = (item) => {
        setEmpData(item)
        setTimeNowForChart(timeNow)
        axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employees/employee-performance?date_str=" + timeNow + "&employee_id=" + item?.user_id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res =>{
                setRadarData(res?.data?.performance)
                // console.log(res?.data?.performance?.length)
            })
    }

    const config = {
        data: radarData?.map((d) => ({ ...d, ball: Math.sqrt(d.ball) })),
        xField: 'name',
        yField: 'ball',
        appendPadding: [0, 10, 0, 10],
        meta: {
            ball: {
                alias: ' %',
                min: 0,
                nice: true,
                formatter: (v) => Number(v).toFixed(2),
            },
        },
        xAxis: {
            tickLine: null,
        },
        yAxis: {
            label: false,
            grid: {
                alternateColor: 'rgba(0, 0, 0, 0.04)',
            },
        },
        // 开启辅助点
        point: {
            size: 2,
        },
        area: {},
    };

    useEffect(() => {
        getBuilding()
        getParentBuilding()
        getCompany()
        getStatistik1(Number(time?.getFullYear()) + "-" + Number(time?.getMonth() + 1) + "-" + Number(time?.getDate()), Number(time?.getFullYear()) + "-" + Number(time?.getMonth() + 1) + "-" + Number(time?.getDate()))

    }, [
        // building_id
    ]);

    return (
        <div className="home-style ">
            <div className="home-left">
                <div className="d-flex justify-content-between mb-3">
                    <h3 className="page-title-main font-family-medium">
                        Обзор активности
                    </h3>
                    <DatePicker
                        placeholder="Фильтр даты"
                        defaultValue={dayjs(time)}
                        onChange={onChangeDate}/>

                </div>
                <div className="tabs-btns">
                    <button onClick={() => {
                        setTabs(1)
                        setTabsTitle("absent")
                        getAll('absent')
                    }}
                            className={tabs === 1 ? "font-family-medium active" : "font-family-medium"}>Отсутствие
                    </button>
                    <button onClick={() => {
                        setTabs(2)
                        setTabsTitle("late")
                        getAll('late')
                    }}
                            className={tabs === 2 ? "font-family-medium active" : "font-family-medium"}>Опоздание
                    </button>
                    <button onClick={() => {
                        setTabs(3)
                        setTabsTitle("on_time")
                        getAll('on_time')
                    }}
                            className={tabs === 3 ? "font-family-medium active" : "font-family-medium"}>Вовремя
                    </button>
                </div>
                <div className="tabs-content">
                    <div className="tabs-content-filter">
                        <div className="center-sv">
                            <label className="font-family-medium mb-2">Раздел</label>
                                <Select
                                    showSearch
                                    placeholder="Выберите раздел"
                                    optionFilterProp="children"
                                    className="w-100 mr-8"
                                    onSearch={getParentBuilding}
                                    onChange={(e) => getBuilding(e)}
                                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    options={parents?.map((item) => {
                                        return {
                                            value: item.id,
                                            label:
                                            item?.branch_title
                                        };
                                    })}
                                />

                        </div>
                        <div className="center-sv">
                            <label className="font-family-medium mb-2">Филиалы</label>
                            <Select
                                showSearch
                                placeholder="Выберите филиал"
                                optionFilterProp="children"
                                className="w-100"
                                value={dateBuFilter}
                                onSearch={getBuilding}
                                onChange={(building_e) => {
                                    onChangeBuDate(building_e)
                                }}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={offices?.map((item) => {
                                    return {
                                        value: item.id,
                                        label:
                                        item?.branch_title
                                    };
                                })}
                            />
                        </div>
                        <div className="center-sv">
                            <label className="font-family-medium mb-2">Отделы</label>
                            <Select
                                showSearch
                                placeholder="Выберите oтделы"
                                optionFilterProp="children"
                                className="w-100"
                                value={dateDeFilter}
                                onSearch={getDeps}
                                onChange={(e) => {
                                    getAllDeps(e)
                                }}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={departments?.map((item) => {
                                    return {
                                        value: item.id,
                                        label:
                                        item?.department_title
                                    };
                                })}
                            />
                        </div>
                    </div>
                    <div className="tabs-lists">
                        {
                            data2?.map((item, index) => (
                                <div className="tabs-list-item " style={{cursor: "pointer"}} onClick={() => forChart(item)}>
                                    <div className="tabs-img-box">
                                        <img src={item?.first_entered_image} alt="avatar"/>
                                    </div>
                                    <div className="tabs-content-box">
                                        <div className="d-flex flex-column justify-center">
                                            <h5 className="font-family-medium">{item?.first_name + " " + item?.last_name}</h5>
                                            <h5 className="font-family-medium">{item?.user_name}</h5>
                                            <h6>{item?.employee?.position}</h6>
                                        </div>
                                        <div className="time-at-work">
                                            <h5 className="font-family-medium"><span className="text-success-working-hours">Первая вход </span><span className="text-white ml-16">{item?.first_entered_time ? item?.first_entered_time?.slice(11, 16) : "--:--"}</span></h5>
                                            <h5 className="font-family-medium"><span className="text-danger-working-hours">Последний выход </span><span className="text-white ml-16">{item?.last_exited_time ? item?.last_exited_time?.slice(11, 16) : "--:--"}</span></h5>
                                            <h5 className="font-family-medium "> <span className="text-warning-working-hours">Рабочее время </span><span className="text-white ml-16">{item?.time_spent_str}</span></h5>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                        {
                            usersObj?.page > 1
                                ?
                                <div className="pag-bottom">
                                    <Stack spacing={2}>
                                        <Pagination count={usersObj?.pages} total={usersObj?.total} current={current}
                                                    onChange={changePagination} shape="rounded"/>
                                    </Stack>
                                </div>
                                :
                                ""
                        }
                    </div>
                </div>
            </div>
            <div className="home-right">
                <div className="my-chart   mt-0" style={{height: "40%"}}>
                    <div className="my-chart-title">
                        <h3 className="font-family-medium">Инфограмма по посещаемости</h3>
                        <RangePicker
                            placeholder={["Дата начала", "Дата окончания"]}
                            defaultValue={[dayjs(moment().startOf('month').format('YYYY-MM-DD'), dateFormat), dayjs(moment().endOf('month').format('YYYY-MM-DD'), dateFormat)]}
                            onChange={onChange}
                            format={dateFormat}
                        />
                    </div>
                    <PieChart series={[{data, innerRadius: 80}]} {...size}>
                        <PieCenterLabel></PieCenterLabel>
                    </PieChart>
                </div>

                {
                    company?.services?.filter(item => item === "visitor_analytics_by_module")?.length > 0 &&  company?.services?.filter(item => item === "visitor_analytics_by_smart_camera")?.length > 0 ?
                        <div className="my-shadow-shokh   " style={{height: "60%"}}>
                            {/*   <h3 className="page-title-main font-family-medium">*/}
                            {/*       Количества зарегистрированных приходов*/}
                            {/*   </h3>*/}
                            {/*   <div className="bigSmallText">*/}
                            {/*       <p className="bigText font-family-extra-bold">*/}

                            {/*           {*/}
                            {/*               Number(late_attendances_count2) + Number(on_time_attendances_count2)*/}
                            {/*           }*/}

                            {/*       </p>*/}
                            {/*       <p className="smallText font-family-medium">*/}
                            {/*    <span>*/}
                            {/*</span>*/}
                            {/*       </p>*/}
                            {/*   </div>*/}
                            {/*   <div className="radio-list">*/}
                            {/*       <div className="left-items">*/}
                            {/*           <FormControl>*/}
                            {/*               <label id="demo-radio-buttons-group-label"*/}
                            {/*                      className="font-family-medium ra-title"> Действие</label>*/}
                            {/*               <RadioGroup*/}
                            {/*                   aria-labelledby="demo-radio-buttons-group-label"*/}
                            {/*                   defaultValue="prixod"*/}
                            {/*                   name="radio-buttons-group"*/}
                            {/*               >*/}
                            {/*                   /!*<FormControlLabel value="all" control={<Radio onChange={() => settopType(2)}/>}*!/*/}
                            {/*                   /!*                  label="Все"/>*!/*/}
                            {/*                   <FormControlLabel value="prixod" control={<Radio onChange={() => settopType(1)}/>}*/}
                            {/*                                     label="Приходов"/>*/}
                            {/*                   /!*<FormControlLabel value="male" control={<Radio onChange={() => settopType(3)}/>}*!/*/}
                            {/*                   /!*                  label="Уходов"/>*!/*/}
                            {/*               </RadioGroup>*/}
                            {/*           </FormControl>*/}
                            {/*       </div>*/}
                            {/*       <div className="left-items">*/}
                            {/*           <FormControl>*/}
                            {/*               <label id="demo-radio-buttons-group-label"*/}
                            {/*                      className="font-family-medium ra-title"> Период</label>*/}

                            {/*               <RadioGroup*/}
                            {/*                   aria-labelledby="demo-radio-buttons-group-label"*/}
                            {/*                   defaultValue="female"*/}
                            {/*                   name="radio-buttons-group"*/}
                            {/*               >*/}
                            {/*                   <FormControlLabel value="female" control={<Radio*/}
                            {/*                       onChange={() => getStatistik2(time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + Number(time?.getDate()), time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + Number(time?.getDate()))}/>}*/}
                            {/*                                     label="Сегодня"/>*/}
                            {/*                   <FormControlLabel value="male" control={<Radio*/}
                            {/*                       onChange={() => getStatistik2(time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + Number(time?.getDate() - 7), time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + Number(time?.getDate()))}/>}*/}
                            {/*                                     label="На этой неделе"/>*/}
                            {/*                   <FormControlLabel value="other" control={<Radio*/}
                            {/*                       onChange={() => getStatistik2(time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-1", time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + Number(Number(JSON.stringify(last_date).slice(9, 11)) + 1))}/>}*/}
                            {/*                                     label="Этот месяц"/>*/}
                            {/*               </RadioGroup>*/}
                            {/*           </FormControl>*/}
                            {/*       </div>*/}
                            {/*   </div>*/}

                            <div className="d-flex justify-content-between">
                                <h3 className="page-title-main font-family-medium mb-1  ">
                                    Эффективность сотрудников
                                </h3>
                                <h3 className="page-title-main font-family-medium">
                                    {
                                        timeNowForChart
                                    }
                                </h3>
                            </div>


                            {
                                radarData?.length > 0
                                    ?
                                    <div className="radar-chart d-flex justify-content-between">
                                        <div>
                                            <Radar {...config} />
                                        </div>
                                        <h3 className="page-title-main font-family-medium mb-1  ">
                                            {
                                                empData?.first_name?.length > 0 ? empData.first_name + " " + empData.last_name : ""
                                            }
                                        </h3>
                                    </div>
                                    :
                                    ""
                            }


                        </div>
                        :
                        ""
                }


            </div>
        </div>
    );
};

export default Home;